import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  template: '',
})
export abstract class BaseComponent implements OnDestroy {

  /** Base-Data-Component Flags */
  public loading: boolean = false;
  public blockPage: boolean = false;
  public dataValidated: boolean = false;
  public dataValid: boolean = false;
  public refreshControls: boolean = false;

  /**
   * subscriptions: subscriptions should be added in components with subscription.add()
   * onDestroy all subscriptions will be unsubscribed
   * @protected
   */
  protected subscriptions = new Subscription();

  ngOnDestroy() {
    /**
     * unsubscribing all subscriptions from the child component
     */
    this.subscriptions.unsubscribe();
  }
}
